import styled from 'styled-components';
import {
  BREAKPOINT,
  PADDING,
  REBRAND_COLOR,
  MARGIN,
  REBRAND_SHADOW
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const StyledCardCollectionCarousel = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ $background }) =>
      $background ? $background : `${REBRAND_COLOR.WHITE}`};
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P64};
  @media (min-width: ${BREAKPOINT.MD}) {
    padding-top: ${PADDING.P64};
    padding-bottom: ${PADDING.P64};
  }
  @media (min-width: ${BREAKPOINT.LG}) {
    padding-bottom: ${PADDING.P80};
  }
  ${({ $componentIdentifier }) => `
    .${$componentIdentifier}-heading {
      margin-bottom: ${MARGIN.M8} !important;

      @media (min-width: ${BREAKPOINT.LG}) {
        margin-bottom: ${MARGIN.M48} !important;
      }
    }
  `}

  &.slider {
    overflow-x: hidden;
    .section__content {
      max-width: 100%;
      overflow-x: visible;
    }
  }
  .slick-track {
    display: flex;
    position: relative;
    margin: 0;
  }

  .slick-slide {
    width: auto !important;
    margin-top: ${MARGIN.M24};
    padding: 0 ${PADDING.P8} ${PADDING.P8} ${PADDING.P8};
    margin-right: 0 !important;
    @media (min-width: ${BREAKPOINT.MD}) {
      margin-right: 0 !important;
      margin-top: ${MARGIN.M32};
      padding: 0 ${PADDING.P8} ${PADDING.P8} ${PADDING.P8};
    }
  }
  .slick-arrow {
    display: none !important;
  }

  .slick-disabled {
    display: none !important;
  }

  .slick-dots {
    display: none !important;
    @media (min-width: ${BREAKPOINT.LG}) {
      display: block !important;
      bottom: -57px;
    }
  }

  .slick-dots li button {
    padding: 0;
  }

  .slick-active {
    margin-right: 15px;
  }

  .slick-dots li button:before {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    background-color: ${REBRAND_COLOR.WHITE};
    border-radius: 50%;
    opacity: 1;
  }

  /* ACTIVE DOT → RECTANGLE */
  .slick-dots li.slick-active button:before {
    width: 24px;
    height: 12px;
    background-color: ${REBRAND_COLOR.GREEN};
    border-radius: 32px;
  }
`;

export const StyledCard = styled.div`
  border-radius: 16px;
  background: ${REBRAND_COLOR.WHITE};
  box-shadow: ${REBRAND_SHADOW.CARD};
  width: 303px !important;
  @media (min-width: ${BREAKPOINT.MD}) {
    width: 290px !important;
  }
`;

export const StyledCardCollectionContainer = styled.div``;

export const StyledCardCollectionImgContainer = styled.div`
 position: relative;
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
`;

export const StyledCardDescription = styled.div``;

export const StyledCardCollectionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: ${PADDING.P32};
`;

export const StyledCardCollectionCTAWrapper = styled.div`
a {
  min-width: auto !important;
}
`;

export const StyledCardHeading = styled.div``;

export const StyledFilterContainer = styled(Section)``;
export const StyledHeadingContainer = styled(Section)`
  margin-bottom: ${MARGIN.M24};
`;

export const StyledSliderContainer = styled(Section)`
  padding-right: 0px !important;
`;
